import { GET_API, POST_API } from './index';
import * as SYSTEM from '../constants/system.keys';

export const getReportAccountApi = async (token, dataHeader, dataQuery) => {
  return GET_API(
    `${SYSTEM.SERVER_URL_CMS}/account-reports/permission`,
    token,
    dataHeader,
    dataQuery,
  );
};

export const getReportAccountCamera = async (token, dataHeader, dataBody) => {
  return POST_API(
    `${SYSTEM.SERVER_URL_CMS}/commands`,
    token,
    dataHeader,
    dataBody,
  );
};

export const getExportReportCameraIncidentApi = async (
  token,
  dataHeader,
  dataBody,
) => {
  return POST_API(
    `${SYSTEM.SERVER_URL_CMS}/commands`,
    token,
    dataHeader,
    dataBody,
    {
      responseType: 'blob',
    },
  );
};
